/**
 * Service worker qeydiyyatı.
 * Yalnız production build-də işləyir — lokal inkişafda (yarn start)
 * köhnə kodun yaddaşda ilişib qalmaması üçün söndürülüb.
 */
const register = () => {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV !== 'production') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        // Hər dəfə sayt açılanda yeni versiya olub-olmadığını yoxla
        reg.update().catch(() => {});
      })
      .catch((err) => {
        console.warn('[PWA] Service worker qeydiyyatı alınmadı:', err);
      });
  });
};

register();

export default register;
